import { APP_BAR_HEIGHT_DESKTOP, Spacing } from "@bonusx-global/bx-design-system";
import { useMediaQuery, useTheme } from "@mui/material";
import type { DrawerProps } from "@mui/material/Drawer";
import MuiDrawer from "@mui/material/Drawer";
import MuiSwipeableDrawer from "@mui/material/SwipeableDrawer";
import noop from "lodash/noop";
import type { PropsWithChildren } from "react";
import { SURVEY_APP_BAR_BORDER_BOTTOM_WIDTH, SURVEY_PROGRESS_BAR_HEIGHT } from "../survey-appbar";

type ResponsiveDrawerProps = PropsWithChildren<{
  isDrawerOpen: boolean;
  handleCloseDrawer: () => void;
}>;

const DesktopPaperProps: NonNullable<DrawerProps["PaperProps"]> = {
  // NOTE: Be aware of the MuiDrawer#styleOverrides global styles
  sx: {
    top: `calc(${APP_BAR_HEIGHT_DESKTOP} + ${SURVEY_APP_BAR_BORDER_BOTTOM_WIDTH} + ${SURVEY_PROGRESS_BAR_HEIGHT})`,
    height: `calc(100dvh - calc(${APP_BAR_HEIGHT_DESKTOP} + ${SURVEY_APP_BAR_BORDER_BOTTOM_WIDTH}))`,
    boxShadow: "0px 0px 20px 0px #00000014;",
    "&.MuiDrawer-paperAnchorRight": {
      width: "360px",
    },
  },
};

const DesktopSlotProps: NonNullable<DrawerProps["slotProps"]> = {
  backdrop: {
    invisible: true,
  },
};

const MobilePaperProps: NonNullable<DrawerProps["PaperProps"]> = {
  // NOTE: Be aware of the MuiDrawer#styleOverrides global styles
  sx: {
    width: "100%",
    maxWidth: "unset",
    borderTopLeftRadius: Spacing[1000],
    borderTopRightRadius: Spacing[1000],
    height: "75%",
  },
};

export function ResponsiveDrawer(props: Readonly<ResponsiveDrawerProps>) {
  const { isDrawerOpen, handleCloseDrawer, children } = props;
  const theme = useTheme();
  const isBreakpointMediumUp = useMediaQuery(theme.breakpoints.up("md"));

  if (isBreakpointMediumUp) {
    return (
      <MuiDrawer
        anchor="right"
        slotProps={DesktopSlotProps}
        PaperProps={DesktopPaperProps}
        open={isDrawerOpen}
        onClose={handleCloseDrawer}
      >
        {children}
      </MuiDrawer>
    );
  }

  return (
    <MuiSwipeableDrawer
      anchor="bottom"
      PaperProps={MobilePaperProps}
      open={isDrawerOpen}
      onClose={handleCloseDrawer}
      // NOTE: The Drawer is only openable by clicking the ? button, so we don't need to open it
      onOpen={noop}
    >
      {children}
    </MuiSwipeableDrawer>
  );
}
